import { toast } from "@/components/Toast";
import { LabelText } from "@/modules/editor/components/styleComponents/Texts";
import { cloudProjectActions } from "@/modules/projects/projectProcessor";
import { DEFAULT_PROJECT_CONFIG } from "@/modules/projects/utils";
// import { cloudProjectsStore } from "@/modules/editor/stores/cloudProject";
// import { getDefaultProjectName } from "@/utils/cloud-local-project";
import { useTranslate } from "@/utils/lang";
import { Editor_Words } from "@/utils/lang/editor";
import { sensitiveWordCheck } from "@/utils/string";
import {
  Button,
  Center,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";

const ICreateProjectModal: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { translate } = useTranslate();
  const [name, setName] = useState(DEFAULT_PROJECT_CONFIG.projectName());
  const [loading, setLoading] = useState(false);

  function handleCancel() {
    onClose();
    setName(DEFAULT_PROJECT_CONFIG.projectName());
  }

  function createProject() {
    setLoading(true);
    sensitiveWordCheck(name)
      .then(() => {
        cloudProjectActions
          .createCloudProject(name || DEFAULT_PROJECT_CONFIG.projectName())
          .finally(() => {
            setLoading(false);
            handleCancel();
          });
      })
      .catch(() => {
        setLoading(false);
        toast({
          status: "error",
          title: translate(Editor_Words["cloud_project_name_sensitive_toast"]),
        });
      });
  }

  function handleCreateProject() {
    if (loading) return;
    createProject();
  }

  useEffect(() => {
    if (open) {
      setName(DEFAULT_PROJECT_CONFIG.projectName());
    }
  }, [open]);

  return (
    <>
      <Modal isCentered variant="dark" size="md" isOpen={open} onClose={handleCancel}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody p="0 78px">
            <Center py="30px" fontSize="18px" fontWeight={500}>
              {translate(Editor_Words["create_cloud_project_header"])}
            </Center>
            <Flex flexDirection="column" mb="5px">
              <LabelText mb="11px">{translate(Editor_Words["rename_for_new_project"])}</LabelText>
              <Input
                maxLength={20}
                size="sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Flex>
          </ModalBody>
          <ModalFooter py="50px">
            <Button
              variant="outline"
              w="120px"
              bg="fill.button"
              borderColor="#595959"
              mr="16px"
              onClick={handleCancel}
            >
              {translate(Editor_Words["cancel_button"])}
            </Button>
            <Button
              w="120px"
              disabled={loading}
              loadingText={translate(Editor_Words["create_new_project_button_text"])}
              isLoading={loading}
              onClick={handleCreateProject}
            >
              {translate(Editor_Words["create_new_project_button_text"])}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export const CreateProjectModal = observer(ICreateProjectModal);
